<template>
  <div class="category-tabs">
    <!-- 横向滚动容器 -->
    <div class="tabs-scroll">
      <div class="tabs-wrap">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="['tab-item', { active: index === currentIndex }]"
          @click="changeType(index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryTabs",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    changeType(index) {
      this.$emit("changeNavType", index);
    },
  },
};
</script>

<style scoped>
.category-tabs {
  position: sticky;
  top: 49px;
  z-index: 10;
  padding: 10px 12px 8px;
  background: rgba(245, 245, 247, 0.9);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
}

/* 横向滚动容器 */
.tabs-scroll {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none; /* 隐藏滚动条 Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.tabs-scroll::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 Chrome/Safari */
}

/* 内部容器用 inline-flex 横排 */
.tabs-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px;
  border-radius: 12px;
  background: #e8e8ed;
}

/* tab 项 */
.tab-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 13px;
  font-size: 13px;
  font-weight: 500;
  color: #6e6e73;
  background: transparent;
  border: 0;
  border-radius: 9px;
  white-space: nowrap;
  flex: 0 0 auto;
  cursor: pointer;
  line-height: 1;
  transition: background 0.18s ease, color 0.18s ease, transform 0.12s ease;
}

/* 选中态 */
.tab-item.active {
  background: #fff;
  color: #1d1d1f;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

/* 点击反馈 */
.tab-item:active {
  transform: scale(0.96);
}
</style>
